// extracted by mini-css-extract-plugin
module.exports = {"header":"_5D3vmvmJ","main":"_5D20_9Sq","button__text":"_5D3MVp9q","button__icon":"_5D3r34_f"};